import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user'
import new_user from './modules/new_user.js'
import tabbar from './modules/tabbar'
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

// const modulesFiles = require.context('./modules', true, /\.js$/)
// //动态转换model
// const modules = modulesFiles.keys().reduce((modules, modulePath) => {
//     // set './app.js' => 'app'
//     const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
//     const value = modulesFiles(modulePath)
//     modules[moduleName] = value.default
//     console.log('modules', modules);
//     return modules
// }, {})

const store = new Vuex.Store({
    modules: {
        tabbar,
        user,new_user
    },
    plugins: [
        //注册模块并保存数据
        createPersistedState({
            storage: window.sessionStorage,
            paths: ["user","tabbar","new_user"]
        })
    ],
});

export default store;
